export function convertToFloatingUi(position) {
    switch (position) {
        case 'up':
            return 'top';
        case 'down':
            return 'bottom';
        case 'left':
            return 'left';
        case 'right':
            return 'right';
        default:
            return 'top';
    }
}
export function getPositionClassName(placement, middlewareData) {
    let className = '';
    className = className.concat(getPlacementWithoutAlignment(placement));
    let alignment = '';
    if (middlewareData.shift) {
        if (middlewareData.shift.x > 0 || middlewareData.shift.y > 0) {
            alignment = '-end';
        }
        else if (middlewareData.shift.x < 0 || middlewareData.shift.y < 0) {
            alignment = '-start';
        }
    }
    if (!alignment) {
        return placement;
    }
    else {
        return className + alignment;
    }
}
export function getPlacementWithoutAlignment(placement) {
    return placement.split('-')[0];
}
export function tryPlacements(triggerRect, position, popoverHeight, popoverOffset) {
    switch (position) {
        case 'top':
            return (tryTopPlacement(triggerRect.top, popoverHeight) ||
                tryBottomPlacement(triggerRect.bottom, popoverHeight) ||
                trySidePlacements(triggerRect.top, triggerRect.bottom, popoverHeight, popoverOffset) ||
                getBestFitPosition(triggerRect.top, triggerRect.bottom, popoverOffset));
        case 'bottom':
            return (tryBottomPlacement(triggerRect.bottom, popoverHeight) ||
                tryTopPlacement(triggerRect.top, popoverHeight) ||
                trySidePlacements(triggerRect.top, triggerRect.bottom, popoverHeight, popoverOffset) ||
                getBestFitPosition(triggerRect.top, triggerRect.bottom, popoverOffset));
        case 'right':
        case 'left':
            return (trySidePlacements(triggerRect.top, triggerRect.bottom, popoverHeight, popoverOffset) ||
                tryBottomPlacement(triggerRect.bottom, popoverHeight) ||
                tryTopPlacement(triggerRect.top, popoverHeight) ||
                getBestFitPosition(triggerRect.top, triggerRect.bottom, popoverOffset));
    }
}
function getBestFitPosition(triggerTop, triggerBottom, popoverOffset) {
    return distanceToBottom(triggerTop, popoverOffset) > distanceToTop(triggerBottom, popoverOffset)
        ? 'right-end'
        : 'right-start';
}
function trySidePlacements(triggerTop, triggerBottom, popoverHeight, popoverOffset) {
    return (trySideCenter(triggerTop, triggerBottom, popoverHeight) ||
        trySideStart(triggerBottom, popoverHeight, popoverOffset) ||
        trySideEnd(triggerTop, popoverHeight, popoverOffset));
}
function tryTopPlacement(triggerTop, popoverHeight) {
    return triggerTop > popoverHeight + 7 ? 'top' : '';
}
function tryBottomPlacement(triggerBottom, popoverHeight) {
    return window.innerHeight - triggerBottom > popoverHeight + 7 ? 'bottom' : '';
}
function trySideCenter(triggerTop, triggerBottom, popoverHeight) {
    return triggerTop > popoverHeight / 2 && window.innerHeight - triggerBottom > popoverHeight / 2
        ? 'right'
        : '';
}
function trySideStart(triggerBottom, popoverHeight, popoverOffset) {
    return distanceToTop(triggerBottom, popoverOffset) > popoverHeight ? 'right-start' : '';
}
function distanceToTop(triggerBottom, popoverOffset) {
    return triggerBottom + popoverOffset;
}
function trySideEnd(triggerTop, popoverHeight, popoverOffset) {
    return distanceToBottom(triggerTop, popoverOffset) > popoverHeight ? 'right-end' : '';
}
function distanceToBottom(triggerTop, popoverOffset) {
    return window.innerHeight - (triggerTop - popoverOffset);
}
export function shiftPopover(popoverRect, position, triggerRect, popoverX, popoverY, popoverOffset) {
    switch (position) {
        case 'top-end':
        case 'bottom-end':
            return shiftPopoverRight(triggerRect, popoverRect, popoverX, popoverY, popoverOffset);
        case 'left-end':
        case 'right-end':
            return shiftPopoverDown(triggerRect, popoverRect, popoverX, popoverY, popoverOffset);
        case 'top-start':
        case 'bottom-start':
            return shiftPopoverLeft(triggerRect, popoverRect, popoverX, popoverY, popoverOffset);
        case 'left-start':
        case 'right-start':
            return shiftPopoverUp(triggerRect, popoverRect, popoverX, popoverY, popoverOffset);
    }
    return { x: 0, y: 0, translateString: '' };
}
function shiftPopoverRight(triggerRect, popoverRect, popoverX, popoverY, popoverOffset) {
    const popoverShiftAmount = { x: 0, y: 0 };
    popoverShiftAmount.x = triggerRect.x - popoverOffset - popoverRect.x;
    popoverShiftAmount.y = 0;
    const translateString = `translate(${popoverShiftAmount.x + popoverX}px, ${popoverY}px)`;
    return {
        x: popoverShiftAmount.x,
        y: popoverShiftAmount.y,
        translateString: translateString,
    };
}
function shiftPopoverDown(triggerRect, popoverRect, popoverX, popoverY, popoverOffset) {
    const popoverShiftAmount = { x: 0, y: 0 };
    popoverShiftAmount.x = 0;
    popoverShiftAmount.y = triggerRect.y - popoverOffset - popoverRect.y;
    const translateString = `translate(${popoverX}px, ${triggerRect.y - popoverOffset - popoverRect.y + popoverY}px)`;
    return {
        x: popoverShiftAmount.x,
        y: popoverShiftAmount.y,
        translateString: translateString,
    };
}
function shiftPopoverLeft(triggerRect, popoverRect, popoverX, popoverY, popoverOffset) {
    const popoverShiftAmount = { x: 0, y: 0 };
    popoverShiftAmount.x = triggerRect.right + popoverOffset - popoverRect.right;
    popoverShiftAmount.y = 0;
    const translateString = `translate(${triggerRect.right + popoverOffset - popoverRect.right + popoverX}px, ${popoverY}px)`;
    return {
        x: popoverShiftAmount.x,
        y: popoverShiftAmount.y,
        translateString: translateString,
    };
}
function shiftPopoverUp(triggerRect, popoverRect, popoverX, popoverY, popoverOffset) {
    const popoverShiftAmount = { x: 0, y: 0 };
    popoverShiftAmount.x = 0;
    popoverShiftAmount.y = triggerRect.bottom + popoverOffset - popoverRect.bottom;
    const translateString = `translate(${popoverX}px, ${triggerRect.bottom + popoverOffset - popoverRect.bottom + popoverY}px)`;
    return {
        x: popoverShiftAmount.x,
        y: popoverShiftAmount.y,
        translateString: translateString,
    };
}
